import { identifierModuleUrl } from "@angular/compiler";
import { Injectable, Logger, OnApplicationBootstrap } from "@nestjs/common";
import { RoleEntity } from "@ip6m/server/data-access-user";
import { date } from "joi";
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { UserEntity } from "libs/server/data-access-user/src/lib/models/user.entity";
import { EntityManager, getManager, getRepository, Repository } from "typeorm";

@Injectable()
export class UserRepositoryService implements OnApplicationBootstrap {

    private userRepository: Repository<UserEntity>;
    private manager: EntityManager;

    onApplicationBootstrap() {
        this.userRepository = getRepository(UserEntity);
        this.manager = getManager();
    }

    async getUsers() {
        return this.userRepository.find({ relations: ["roles"]});
    }

    async addRoles(roles) {
        for(const id in roles)  {
            const entity = new RoleEntity();
            entity.id = parseInt(id);
            entity.name = roles[id];
            await this.manager.save(entity);
            Logger.log('Role ' + entity.name + ' (' + entity.id + ') has been saved.');
        }
    }

    async setPassword(id, hash) {
        const entity = new UserEntity();
        entity.id = id;
        entity.password = hash;
        return this.manager.save(entity);
    }


}